import React from "react";
import style from "./Buttons.module.css";
export default function OutlinedButton(props) {
  const { text, btnClass = "", ...restProps } = props;
  return (
    <button className={`${style.outlinedBtn} ${btnClass}`} {...restProps}>
      {text}
    </button>
  );
}
